import {TRONWalletAdapter} from "../lib/WalletAdapter";
import {TronLinkAdapter} from "../lib/tron/TronLinkAdapter";
import {useEffect, useState} from "react";
import {BitgetAdapter} from "../lib/tron/BitgetAdapter";
import {OKXAdapter} from "../lib/tron/OKXAdapter";

export const useTRONWallet = () => {

    const wallets: TRONWalletAdapter[] = [new TronLinkAdapter(), new BitgetAdapter(),new OKXAdapter()];
    const [installedWallets, setInstalledWallets] = useState<TRONWalletAdapter[]>([]);
    const [address, setAddress] = useState<string | null>(null);
    useEffect(() => {
        const getInstalled = async () => {
            const installed = await Promise.all(wallets.map(wallet => wallet.isInstalled().then(isInstalled => ({
                wallet,
                isInstalled
            }))));
            setInstalledWallets(installed.filter(({isInstalled}) => isInstalled).map(({wallet}) => wallet));
        };
        // console.log('getInstalled');
        getInstalled();
    }, []);

    const [wallet, chooseWallet] = useState<TRONWalletAdapter | null>(null);

    const onConnect = async () => {
        setAddress(await wallet!.connect());
    }
    useEffect(() => {

        if (!wallet) {
            setAddress(null)
        }
    }, [wallet]);

    return {
        installedWallets,
        wallets,
        chooseWallet,
        wallet,
        address,
        onConnect

    }

}